@if (loading | async) {
    <div class="d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="property-detail container-fluid p-3 mb-5" *ngIf="property">
        <div class="w-fit" *ngIf="!disableActions">
            <app-back-button url="/properties" component="Properties"></app-back-button>
        </div>
        <div class="mt-3 d-flex justify-content-between align-items-center" id="property-header-row">
            <div class="font-weight-bold">
                <h1>{{ property.property_name }}</h1>
            </div>
            <div class="d-flex mt-2 me-1" *ngIf="!disableActions">
                <button mat-raised-button *ngIf="tabIndex !== 4" class="action-button d-flex col-auto align-items-center"
                    (click)="onEditPropertyClick()" style="margin-right:8px;">
                    <mat-icon class="button-icon">edit</mat-icon>
                    Edit Property
                </button>
                <button mat-raised-button *ngIf="tabIndex === 4" class="action-button d-flex col-auto align-items-center"
                (click)="onAssignPolicyClick()" [disabled]="!policiesAvailableBoolean" style="margin-right:8px;">
                    <mat-icon class="button-icon">add</mat-icon>
                    Assign
                </button>
                <button mat-raised-button *ngIf="tabIndex != 4 && property.status.id === 2" class="action-button d-flex col-auto align-items-center" (click)="openUpdatePropertyStatusDialog()">
                    <mat-icon class="button-icon">edit</mat-icon>
                    Activate Property
                </button>
                <button mat-raised-button *ngIf="tabIndex != 4 && property.status.id === 1" class="warn-button" (click)="openUpdatePropertyStatusDialog()">
                    <mat-icon class="button-icon">edit</mat-icon>
                    Deactivate Property
                </button>
            </div>
        </div>
        <mat-card class="mt-3 pb-5">
            <mat-tab-group mat-align-tabs="center" dynamicHeight animationDuration="0ms" (selectedTabChange)="tabChanged($event)">
                <mat-tab label="Basic Info">
                    <div class="p-2">
                        <app-detail-info-card class="col-12" [data]="basicInfo" [fullRowData]="description" [disableShadow]="true"></app-detail-info-card>
                    </div>
                </mat-tab>
                <mat-tab label="Address">
                    <div class="p-2">
                        <app-detail-info-card [data]="address" [disableShadow]="true"></app-detail-info-card>
                    </div>
                </mat-tab>
                <mat-tab label="Photos">
                    <div class="row flex-row photos-container p-2" *ngIf="photos.length > 0; else noPhotos">
                        <img *ngFor="let photo of photos" [src]="photo" class="rounded photo m-2" (error)="couldNotLoadPhoto(photo)"/>
                    </div>
                    <ng-template #noPhotos>
                        <div class="row pt-5 justify-content-center">
                            <div class="w-100 d-flex justify-content-center" style="font-size:11pt;">
                                No photos available.
                            </div>
                        </div>
                    </ng-template>
                </mat-tab>
                <mat-tab label="Homeowner">
                    <div class="p-2">
                        <app-detail-info-card [data]="homeowner" [disableShadow]="true"></app-detail-info-card>
                    </div>
                </mat-tab>
                <mat-tab label="Assigned Policies">
                    <div class="row">
                        <div *ngIf="policyTableLength<=0; else policyTable">
                            <div class="row justify-content-center">
                                <div class="w-100 d-flex justify-content-center mt-5" style="font-size:11pt;">
                                    Organization's default policy applies to this property.
                                </div>
                            </div>
                        </div>
                        <ng-template #policyTable>
                            <app-shared-policy-table
                                [dataSource]="policyDataSource"
                                [displayedColumns]="policyColumns"
                                [component]="'Insurance Policies'"
                                [displayLoadingIndicator]="loading"
                                [propertyHasPrimaryPolicy]="propertyHasPrimaryPolicy"
                                [tableLength]="policyTableLength"
                                [getStatusColor]="getPolicyPrimaryColorForTable"
                                (actionClickedEvent)="onViewRangesOpenClick($event)"
                                (editPolicyClickEvent)="onEditPolicyClick($event)"
                                (updatePolicyClickEvent)="onUpdatePrimaryPolicyClick($event)"
                                (deletePolicyClickEvent)="onDeletePolicyClick($event)">
                            </app-shared-policy-table>
                        </ng-template>
                    </div>
                </mat-tab>
                <mat-tab label="Property Claims">
                    <app-property-claims [propertyOrganizationId]="property.organization_id" [propertyId]="propertyId"></app-property-claims>
                </mat-tab>
                <mat-tab label="Property Reservations">
                    <app-property-reservations [propertyOrganizationId]="property.organization_id" [propertyId]="propertyId"></app-property-reservations>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>
}